import Notiflix from "notiflix";
import { Row, Col, FloatingLabel, Form, Button } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";

const CareerForm = ({
  Enquiry,
  setEnquiry,
  onFileChange,
  selectedFile,
  isVerified,
  captcha_number,
  captchaVerify,
  recaptchaRef,
  handleSubmit,
}) => {
  return (
    <>
      <div className="form-box" style={{ color: "#fff" }}>
        <h3>Apply Now</h3>
        <p>
          Fill out the form and send us a message. We'd love to hear from you!
        </p>
        <div className="form-input">
          <FloatingLabel className="mb-3">
            <Form.Select
              name="job"
              value={Enquiry.job}
              onChange={(e) =>
                setEnquiry({
                  ...Enquiry,
                  [e.target.name]: e.target.value,
                })
              }>
              <option value="">Select Job Title</option>
              <option value="Social Media Intern">Social Media Intern</option>
              <option value="SEO Intern">SEO Intern</option>
              {/* <option value="Web Designer">
                Web Designer
              </option>
              <option value="Mobile App Developer">Mobile App Developer</option>
              <option value="Web Developer">Web Developer</option>
              <option value="Sales Manager">Sales Manager</option>
              <option value="Telemarketing Executive">Telemarketing Executive</option>
              <option value="Business Development Executive">Business Development Executive</option>
              <option value="Telesales Executive">Telesales Executive</option>
              <option value="Fieldsales Executive">Fieldsales Executive</option>
              <option value="Content Writer">Content Writer</option>
              <option value="Social Media Executive">Social Media Executive</option> */}
            </Form.Select>
          </FloatingLabel>
          <FloatingLabel label="Name *" className="mb-3">
            <Form.Control
              type="text"
              placeholder=""
              name="name"
              value={Enquiry.name}
              onChange={(e) =>
                setEnquiry({
                  ...Enquiry,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </FloatingLabel>
        </div>
        <div className="form-input">
          <FloatingLabel label="Mobile Number *" className="mb-3">
            <Form.Control
              type="text"
              placeholder=""
              name="mobile"
              value={Enquiry.mobile}
              onChange={(e) => {
                if (e.target.value.length <= 10)
                  setEnquiry({
                    ...Enquiry,
                    [e.target.name]: e.target.value.replace(/\D/g, ""),
                  });
              }}
            />
          </FloatingLabel>
          <FloatingLabel label="Email *" className="mb-3">
            <Form.Control
              type="text"
              placeholder=""
              name="email"
              value={Enquiry.email}
              onChange={(e) =>
                setEnquiry({
                  ...Enquiry,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </FloatingLabel>
        </div>

        <Col lg={12} className="mb-3 inputFile">
          <Form.Label className="small mb-1">
            Attach your CV (.pdf,.doc,.docx)
          </Form.Label>
          <Form.Control type="file" size="sm" onChange={onFileChange} />
        </Col>

        <Col lg={12}>
          <FloatingLabel label="Message" className="mb-3">
            <Form.Control
              as="textarea"
              style={{ height: "100px" }}
              name="message"
              value={Enquiry.message}
              onChange={(e) =>
                setEnquiry({
                  ...Enquiry,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </FloatingLabel>
        </Col>

        <div className="col-12">
          <ReCAPTCHA
            sitekey="6LcAbmIrAAAAAA3cVWVr9QtRXY4TelU57UbBMDFp"
            onChange={captchaVerify}
            ref={recaptchaRef}
          />
        </div>

        <Col className="d-lg-flex justify-content-end align-items-center mt-3">
          <Button
            className="btn btn-primary w-100"
            onClick={() => {
              if (!Enquiry.job) {
                Notiflix.Notify.failure("Please select job title");
              } else {
                handleSubmit();
              }
            }}
            style={{ backgroundColor: "#ff600c", border: "1px solid #ff600c" }}>
            Submit
          </Button>
        </Col>
      </div>
    </>
  );
};

export default CareerForm;
